import styled from 'styled-components';

const StyledQuestionBlock = styled.div`
  margin-bottom: 20px;
`;

const StyledQuestionLabel = styled.div`
  margin-bottom: 10px;
`;

export {
  StyledQuestionBlock,
  StyledQuestionLabel,
};
